import SiteMenu from "../components/menu";

export default function PanelPage() {
    return <>
        <SiteMenu />
    </>
}
